import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ValueProps = _resolveComponent("ValueProps")!
  const _component_Demo1 = _resolveComponent("Demo1")!
  const _component_MealManagement = _resolveComponent("MealManagement")!
  const _component_MealInput = _resolveComponent("MealInput")!
  const _component_Demo2 = _resolveComponent("Demo2")!
  const _component_Demo3 = _resolveComponent("Demo3")!
  const _component_Demo4 = _resolveComponent("Demo4")!
  const _component_Demo5 = _resolveComponent("Demo5")!
  const _component_DownloadCta = _resolveComponent("DownloadCta")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isMainRoute)
      ? (_openBlock(), _createBlock(_component_Header, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: "fade",
      mode: "in-out"
    }, {
      default: _withCtx(() => [
        (_ctx.isMainRoute)
          ? (_openBlock(), _createBlock(_component_ValueProps, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade",
      mode: "in-out"
    }, {
      default: _withCtx(() => [
        (_ctx.isMainRoute)
          ? (_openBlock(), _createBlock(_component_Demo1, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade",
      mode: "in-out"
    }, {
      default: _withCtx(() => [
        (_ctx.isMainRoute)
          ? (_openBlock(), _createBlock(_component_MealManagement, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade",
      mode: "in-out"
    }, {
      default: _withCtx(() => [
        (_ctx.isMainRoute)
          ? (_openBlock(), _createBlock(_component_MealInput, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade",
      mode: "in-out"
    }, {
      default: _withCtx(() => [
        (_ctx.isMainRoute)
          ? (_openBlock(), _createBlock(_component_Demo2, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade",
      mode: "in-out"
    }, {
      default: _withCtx(() => [
        (_ctx.isMainRoute)
          ? (_openBlock(), _createBlock(_component_Demo3, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade",
      mode: "in-out"
    }, {
      default: _withCtx(() => [
        (_ctx.isMainRoute)
          ? (_openBlock(), _createBlock(_component_Demo4, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade",
      mode: "in-out"
    }, {
      default: _withCtx(() => [
        (_ctx.isMainRoute)
          ? (_openBlock(), _createBlock(_component_Demo5, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade",
      mode: "in-out"
    }, {
      default: _withCtx(() => [
        (_ctx.isMainRoute)
          ? (_openBlock(), _createBlock(_component_DownloadCta, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade",
      mode: "in-out"
    }, {
      default: _withCtx(() => [
        (!_ctx.isMainRoute)
          ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}